import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuth } from '@hooks/auth/useAuth';

import type { JSX } from 'react';

/**
 * `/admin/logout` — restores the legacy OAuth logout route. Runs the standard
 * logout sequence on mount (`useAuth().signOut` clears the session token + auth
 * slice and redirects to /signin) so direct links and old bookmarks log the
 * user out instead of falling through to the 404 catch-all. Logout via the user
 * menu is unchanged.
 */
export function LogoutPage(): JSX.Element {
  const { t } = useTranslation('auth');
  const { signOut } = useAuth();

  useEffect(() => {
    void signOut();
  }, [signOut]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-4 py-12">
      <div className="w-full max-w-md">
        <Card data-testid="logout-page">
          <CardHeader>
            <CardTitle>{t('logout.title', { defaultValue: 'Signing you out…' })}</CardTitle>
            <CardDescription className="flex items-center gap-2">
              <Loader2 className="h-4 w-4 animate-spin" />
              <span>OrderMesh</span>
            </CardDescription>
          </CardHeader>
        </Card>
      </div>
    </main>
  );
}
